import request from '@/utils/request'

let LineupApi = {

  /*排队池列表*/
  list(data) {
    return request._post('/shop/plus.lineup.Index/index', data);
},
/*添加排队池*/
add(data) {
    return request._post('/shop/plus.lineup.Index/add', data);
},
/*修改排队池*/
edit(data) {
    return request._post('/shop/plus.lineup.Index/edit', data);
},
/*删除排队池*/
del(data) {
    return request._post('/shop/plus.lineup.Index/del', data);
},
/*排队池详情*/
detail(data) {
  return request._post('/shop/plus.lineup.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.lineup.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.lineup.Setting/getSetting', data, errorback);
    },


       /*列表*/
       getProduct(data) {
        return request._get('/shop/plus.lineup.product/index', data);
    },
    /*添加*/
    addProduct(data) {
        return request._post('/shop/plus.lineup.product/add', data);
    },
    /*编辑*/
    editProduct(data) {
        return request._post('/shop/plus.lineup.product/edit', data);
    },
    /*删除*/
    delProduct(data) {
        return request._post('/shop/plus.lineup.product/delete', data);
    },
    getProducts(data) {
        return request._post('/shop/plus.lineup.product/getProducts', data);
    },
}
export default LineupApi;



// WEBPACK FOOTER //
// ./src/api/lineup.js